import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView, useReducedMotion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import config from '../../config/restoSeoPhotos.json';

const SLOTS = [
  { left: '0%', top: '44%', rotate: -3, scale: 1, zIndex: 30 },
  { left: '36%', top: '0%', rotate: 3, scale: 0.94, zIndex: 20 },
  { left: '36%', top: '40%', rotate: 6, scale: 0.86, zIndex: 10 },
];

export const RestoSeoPhotos: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { t } = useTranslation('resto');
  const alt = t('images.restaurantInterior', { defaultValue: 'Restaurant interior' });
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { margin: '-10% 0px' });
  const reduce = useReducedMotion();
  const [step, setStep] = useState(0);
  const photos = config.photos;

  useEffect(() => {
    if (!inView || reduce) return undefined;
    const id = window.setInterval(() => setStep((s) => s + 1), config.cycleSeconds * 1000);
    return () => window.clearInterval(id);
  }, [inView, reduce]);

  return (
    <div ref={ref} className={`relative mx-auto aspect-square w-full max-w-xl ${className}`}>
      {photos.map((photo, index) => {
        const slot = SLOTS[(index + step) % SLOTS.length];
        return (
          <motion.div
            key={photo.src}
            className="absolute w-[64%]"
            initial={reduce ? false : { opacity: 0, y: 40 }}
            animate={inView || reduce ? { opacity: 1, y: 0, ...slot } : undefined}
            style={{ zIndex: slot.zIndex }}
            transition={{
              type: 'spring',
              stiffness: 70,
              damping: 16,
              opacity: { duration: 0.6, delay: index * 0.15 },
              y: { duration: 0.8, delay: index * 0.15 },
            }}
          >
            <img
              src={photo.src}
              alt={index === 0 ? alt : ''}
              width={photo.width}
              height={photo.height}
              loading="lazy"
              decoding="async"
              className="w-full rounded-[1.75rem] object-cover shadow-2xl ring-8 ring-komby-cream"
            />
          </motion.div>
        );
      })}
    </div>
  );
};
